import { SpeechRecognitionTask } from "./SpeechRecognitionTask.js";
export class SpeechRecognizer {
    endpoint;
    activeTask = null;
    constructor(config) {
        this.endpoint = config?.endpoint ?? "/api/transcribe";
    }
    static async requestAuthorization() {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            stream.getTracks().forEach((t) => t.stop());
            return "authorized";
        }
        catch (err) {
            if (err.name === "NotAllowedError")
                return "denied";
            if (err.name === "NotFoundError")
                return "restricted";
            return "denied";
        }
    }
    recognitionTask() {
        if (this.activeTask) {
            this.activeTask.cancel();
        }
        const task = new SpeechRecognitionTask(this.endpoint, () => {
            if (this.activeTask === task)
                this.activeTask = null;
        });
        this.activeTask = task;
        return task;
    }
    get isAvailable() {
        return (typeof navigator !== "undefined" &&
            !!navigator.mediaDevices &&
            !!navigator.mediaDevices.getUserMedia);
    }
}
